import React from 'react';
import { Link } from 'react-router-dom';
import { mockCompanyInfo } from '../mock';

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-300 py-24 relative noise-overlay">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-4">
            <Link to="/" className="inline-block mb-6">
              <span className="text-2xl font-bold text-white" style={{ fontFamily: 'var(--font-heading)' }}>
                Quidity<span className="text-[#115E59]">.</span>
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm mb-6">
              Cashflow Engineering for ambitious business owners and referral partners. Financing, processing, and intelligent management systems.
            </p>
            <div className="text-sm space-y-1">
              <p className="text-slate-400">{mockCompanyInfo.phone}</p>
              <p className="text-slate-400">{mockCompanyInfo.email}</p>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold text-white uppercase tracking-[0.2em] mb-6">Solutions</h4>
            <ul className="space-y-3">
              <li><Link to="/solutions/term-loans" className="text-sm text-slate-400 hover:text-white transition-colors">Term Loans</Link></li>
              <li><Link to="/solutions/jumbo-term-loan" className="text-sm text-slate-400 hover:text-white transition-colors">Jumbo Term Loan</Link></li>
              <li><Link to="/solutions/hybrid-loc" className="text-sm text-slate-400 hover:text-white transition-colors">Hybrid Term / LOC</Link></li>
              <li><Link to="/solutions/lines-of-credit" className="text-sm text-slate-400 hover:text-white transition-colors">Lines of Credit</Link></li>
              <li><Link to="/solutions/equipment-financing" className="text-sm text-slate-400 hover:text-white transition-colors">Equipment Financing</Link></li>
              <li><Link to="/solutions/sba-grocery" className="text-sm text-slate-400 hover:text-white transition-colors">SBA Grocery Program</Link></li>
              <li><Link to="/solutions/sba-made-in-america" className="text-sm text-slate-400 hover:text-white transition-colors">SBA Made in America</Link></li>
              <li><Link to="/solutions/real-estate" className="text-sm text-slate-400 hover:text-white transition-colors">Real Estate Finance</Link></li>
              <li><Link to="/solutions/merchant-processing" className="text-sm text-slate-400 hover:text-white transition-colors">Merchant Processing</Link></li>
              <li><Link to="/solutions/management-systems" className="text-sm text-slate-400 hover:text-white transition-colors">Management Systems</Link></li>
              <li><Link to="/solutions/transportation-finance" className="text-sm text-slate-400 hover:text-white transition-colors">Transportation Finance</Link></li>
              <li><Link to="/solutions/foreclosure-bailout" className="text-sm text-slate-400 hover:text-white transition-colors">Foreclosure Bailout</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold text-white uppercase tracking-[0.2em] mb-6">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-slate-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/academy" className="text-sm text-slate-400 hover:text-white transition-colors">Academy</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/partner" className="text-sm text-slate-400 hover:text-white transition-colors">Partner Program</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold text-white uppercase tracking-[0.2em] mb-6">Headquarters</h4>
            <p className="text-sm text-slate-400 leading-relaxed">
              {mockCompanyInfo.address.street}<br />
              {mockCompanyInfo.address.suite}<br />
              {mockCompanyInfo.address.city}, {mockCompanyInfo.address.state} {mockCompanyInfo.address.zip}
            </p>
            <div className="mt-6 flex gap-4">
              <Link
                to="/apply"
                data-testid="footer-apply-cta"
                className="text-sm font-semibold bg-[#115E59] text-white rounded-sm px-5 py-2.5 hover:bg-[#0d4f4a] transition-colors"
              >
                Apply Now
              </Link>
              <a
                href="https://portal.quidity.fund/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-portal-link"
                className="text-sm font-semibold text-slate-400 border border-slate-700 rounded-sm px-5 py-2.5 hover:text-white hover:border-slate-500 transition-colors"
              >
                Portal Login
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div>
            <p className="text-xs text-slate-500">&copy; {new Date().getFullYear()} Quidity Direct. All rights reserved.</p>
            <p className="text-xs text-slate-500 mt-1">Quidity Direct is a wholly owned brand of Mount Irvine Capital Group, LLC</p>
          </div>
          <div className="flex gap-6">
            <span className="text-xs text-slate-500">Privacy Policy</span>
            <span className="text-xs text-slate-500">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
